import { ConnectedPosition } from '@angular/cdk/overlay';

const ITEM_POSITIONS: ConnectedPosition[] = [
  {
    originX: 'end',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'top',
    offsetX: 16,
    offsetY: -56,
    panelClass: ['sp-custom', 'point-from-top', 'point-to-left'],
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: -12,
    offsetY: -56,
    panelClass: ['sp-custom', 'point-from-top', 'point-to-right'],
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetX: 16,
    offsetY: 36,
    panelClass: ['sp-custom', 'point-from-bottom', 'point-to-left'],
  },
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetX: -12,
    offsetY: 36,
    panelClass: ['sp-custom', 'point-from-bottom', 'point-to-right'],
  },
];

const MOVE_FLOOR_POSITIONS: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: 48,
    offsetY: 20,
    panelClass: ['sp-custom', 'point-from-top', 'point-to-right'],
  },
];

export const OVERLAY_CONNECTED_POSITIONS = {
  moveFloor: MOVE_FLOOR_POSITIONS,
  item: ITEM_POSITIONS,
};
